export default {
  path: '/check-card',
  meta: {
    title: '商家核销',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/check-card`),
}



// WEBPACK FOOTER //
// ./src/views/checkCard/router.js